import { render, staticRenderFns } from "./cabnet-insurance-company.vue?vue&type=template&id=6f0c5c6e&"
import script from "./cabnet-insurance-company.vue?vue&type=script&lang=js&"
export * from "./cabnet-insurance-company.vue?vue&type=script&lang=js&"
import style0 from "./cabnet-insurance-company.vue?vue&type=style&index=0&id=6f0c5c6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports